// extracted by mini-css-extract-plugin
export default {"grid":"FirstFourField_grid__fpKYq","boxed":"FirstFourField_boxed__o9ehr"};